import FindAPartner from './FindAPartner'

export default FindAPartner
